export default __webpack_public_path__ + "static/media/1.0fae18e9.jpg";